import { connect } from "react-redux";

import { sendGAEvent } from "rivals/redux/ga/actions";
import {
  getBillingInformationConstants,
  getIsSubscribable,
  getSelectedSite,
  getSubscriptionPricingConstants
} from "rivals/redux/rails/selectors";
import { State } from "rivals/redux/reducer";
import { giftSubscription } from "rivals/redux/registration/actions";
import {
  getGiftPricing,
  selectGiftPricingError
} from "rivals/redux/registration/selectors";
import { resetPayPal, updatePayPalError } from "rivals/redux/user/actions";
import {
  getPayPalAddress,
  getPayPalEmail,
  getPayPalError,
  getPayPalToken,
  getSubmitting
} from "rivals/redux/user/selectors";
import { StateProps } from "./types";
import Gifts from "./";

const mapStateToProps = (state: State): StateProps => ({
  billingConstants: getBillingInformationConstants(state),
  currentSite: getSelectedSite(state),
  giftPricing: getGiftPricing(state),
  giftPricingError: selectGiftPricingError(state),
  isSiteSubscribable: getIsSubscribable(state),
  payPalAddress: getPayPalAddress(state),
  payPalEmail: getPayPalEmail(state),
  payPalError: getPayPalError(state),
  payPalToken: getPayPalToken(state),
  pricingConstants: getSubscriptionPricingConstants(state),
  submitting: getSubmitting(state)
});

const mapDispatchToProps = {
  giftSubscription,
  resetPayPal,
  sendGAEvent,
  updatePayPalError
};

export default connect(mapStateToProps, mapDispatchToProps)(Gifts);
